import { FormalizeCandidate, FormalizeCompany, FormalizeJobMatch, FormalizeRequisition } from 'src/app/public/app/models/formalizePayload';
var ConferenceController = /** @class */ (function () {
    /*@ngInject*/
    function ConferenceController($rootScope, $timeout, $uibModal, $filter, moment, companyService, jobMatchService, meetingService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.$filter = $filter;
        this.moment = moment;
        this.companyService = companyService;
        this.jobMatchService = jobMatchService;
        this.meetingService = meetingService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    ConferenceController.prototype.$onInit = function () {
        var _this = this;
        this.isLoading = true;
        this._setContext();
        this.$rootScope.hideNav = true;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporate = this.companyService.isCorporateCompany();
        this.participantName = this.$rootScope.userDetails.firstname + ' ' + this.$rootScope.userDetails.lastname;
        this.isLoadingMeetingLink = true;
        if (this.context !== 'candidateCard') {
            if (this.scheduleId) {
                this._getScheduledMeetingDetails(function (data) {
                    _this._getCandidateJobMatchInfo(function () {
                        _this.scheduleInfo = _this.meetingService.getMassagedMeetingDetails(data);
                        _this.isLoading = false;
                    }, function (error) {
                        _this.isLoading = false;
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                });
            }
            else if (this.workflowStep == 'rs') {
                this._getCandidateJobMatchInfo(function () {
                    _this.isLoading = false;
                }, function (error) {
                    _this.isLoading = false;
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }
        }
    };
    ConferenceController.prototype._setContext = function () {
        if (this.jobMatchId) {
            this.context = "candidateJobMatchCard";
        }
        else if (this.candidateId) {
            this.context = "candidateCard";
            this.isLoading = false;
        }
        else {
            this.context = "schedule";
        }
        this.displayAllSchedule = false;
        if (this.jobMatchId && (this.workflowStep === 'ps' || this.workflowStep == 'in')) {
            this.displayAllSchedule = true;
        }
    };
    ConferenceController.prototype._getCandidateJobMatchInfo = function (successCallback, errorCallback) {
        var _this = this;
        this.isLoading = true;
        this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, function (data) {
            _this.candidateJobMatch = data;
            _this.candidateJobMatch.name = data.firstName + ' ' + data.lastName;
            _this.candidateId = data.id;
            _this.jobId = data.jobMatchJobId;
            _this.setFormalizeActivityPayload();
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            if (errorCallback) {
                errorCallback();
            }
        });
    };
    ConferenceController.prototype._getScheduledMeetingDetails = function (successCallback) {
        var _this = this;
        this.jobMatchService.getMeetingDetails(this.scheduleId, function (data) {
            _this.candidateId = data.candidateDetail.id;
            _this.jobId = data.jobId;
            _this.jobMatchId = data.jobMatchId;
            if (successCallback) {
                successCallback(data);
            }
        }, function (error) {
            _this.isLoading = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    ConferenceController.prototype.setFormalizeActivityPayload = function () {
        this.formalizeActivityPayload = {
            candidate: new FormalizeCandidate(this.candidateId, this.candidateJobMatch.firstName, this.candidateJobMatch.lastName),
            requisition: new FormalizeRequisition(this.jobId, this.candidateJobMatch.jobMatchRequisitionNum, this.candidateJobMatch.jobMatchTitle),
            jobMatch: new FormalizeJobMatch(this.candidateJobMatch.jobMatchId, this.jobId, this.candidateJobMatch.jobMatchRequisitionNum, this.candidateJobMatch.jobMatchTitle),
            company: new FormalizeCompany(this.companyId, this.candidateJobMatch.currentJobCompanyName, this.candidateJobMatch.clientOrBUId, this.candidateJobMatch.clientOrBUName)
        };
    };
    return ConferenceController;
}());
ConferenceController.$inject = ['$rootScope', '$timeout', '$uibModal', '$filter', 'moment', 'companyService', 'jobMatchService', 'meetingService', 'alertsAndNotificationsService'];
import * as TEMPLATE from 'raw-loader!./conference.html';
export var ConferenceComponent = {
    selector: 'conference',
    component: {
        bindings: {
            scheduleId: '@',
            candidateId: '@',
            jobId: '@',
            jobMatchId: '@',
            workflowStep: '@',
            type: '@',
            mode: '@'
        },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/conference/conference/conference.html',
        controller: ConferenceController
    }
};
//# sourceMappingURL=conference.component.js.map